var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-info text-white py-3 px-4 z-index-3 position-relative" },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("i", { staticClass: "fa fa-envelope mr-1" }),
        _vm._v(
          "\n        " +
            _vm._s(
              _vm._f("trans")(
                "Please verify your email address to get another %pendingCredits% Credits. Your account is limited without verifying your email address.",
                { "%pendingCredits%": this.pendingCredits }
              )
            ) +
            "\n        "
        ),
        _c(
          "button",
          {
            staticClass: "ml-3 btn btn-outline-light",
            on: {
              click: function ($event) {
                _vm.showResend = !_vm.showResend
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("trans")("Fix now")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.showResend
        ? _c("div", { staticClass: "mt-4" }, [
            _c("div", {
              staticClass: "mt-2",
              domProps: { innerHTML: _vm._s(_vm.emailText) },
            }),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm._f("trans")("Click the confirmation link in your email.")
                )
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light mr-3",
                  attrs: { disabled: _vm.disableResend },
                  on: { click: _vm.resendConfirmation },
                },
                [
                  _c("i", { staticClass: "fa fa-envelope mr-1" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm._f("trans")("Resend confirmation email")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "ml-3 btn btn-outline-light",
                  on: { click: _vm.goToDashboard },
                },
                [
                  _c("i", { staticClass: "fa fa-edit mr-3" }),
                  _vm._v(
                    _vm._s(_vm._f("trans")("Change email address")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showResendSuccess
        ? _c("div", {
            staticClass: "alert alert-success text-white mt-3",
            domProps: { innerHTML: _vm._s(_vm.resentText) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }